import React from 'react';
import { Label } from '@/shared/ui/label';
import { Input } from '@/shared/ui/input';

const INPUT_CLASS = 'text-[#868C98] font-normal';

export function AuthTextField({
  id,
  label,
  value,
  onChange,
  placeholder,
  type = 'text',
  required = false,
  autoComplete,
  name,
}) {
  return (
    <div className="flex flex-col space-y-1.5 w-full">
      <Label htmlFor={id} className="font-semibold">
        {label}
      </Label>
      <Input
        required={required}
        id={id}
        name={name || id}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        className={INPUT_CLASS}
      />
    </div>
  );
}
